/**
 * Russian strings of the client card and the inbox's filters and payment link (see
 * `uz-w1-client-inbox.ts`). Spread into `ru`; a key missing here falls back to Uzbek.
 */
import type { TranslationKey } from "./uz";

export const ruClientInboxW1: Partial<Record<TranslationKey, string>> = {
  "clientCardW1.ai.label": "AI не отвечает",
  "clientCardW1.ai.on": "AI не отвечает этому клиенту",
  "clientCardW1.ai.failed": "Не удалось сохранить настройку.",

  "clientCardW1.identity.primary": "Основной",

  "clientCardW1.portrait.title": "Портрет",
  "clientCardW1.portrait.error": "Не удалось загрузить портрет.",
  "clientCardW1.portrait.children": "Возраст детей",
  "clientCardW1.portrait.budget": "Бюджет",
  "clientCardW1.portrait.perPerson": "на человека",
  "clientCardW1.portrait.styles": "Стиль отдыха",
  "clientCardW1.portrait.liked": "Понравившиеся отели",
  "clientCardW1.portrait.disliked": "Не понравившиеся отели",
  "clientCardW1.portrait.previous": "Прошлые направления",
  "clientCardW1.portrait.contactNote": "Заметка о связи",
  "clientCardW1.portrait.passport": "Статус паспорта",
  "clientCardW1.portrait.note": "Заметка",
  "clientCardW1.portrait.aiExtracted": "Извлёк AI, не подтверждено",
  "clientCardW1.portrait.aiSuggested": "AI предлагает: {value}",
  "clientCardW1.portrait.confirm": "Подтвердить",
  "clientCardW1.portrait.dismiss": "Отклонить",
  "clientCardW1.portrait.decideFailed": "Не удалось сохранить решение.",

  "clientCardW1.payments.tab": "Платежи",
  "clientCardW1.payments.label": "Платежи клиента",
  "clientCardW1.payments.error": "Не удалось загрузить платежи",
  "clientCardW1.payments.retry": "Повторить",
  "clientCardW1.payments.empty": "Платежей нет",
  "clientCardW1.payments.denied": "Нет доступа к этому разделу",
  "clientCardW1.payments.ownOnly": "Видны только платежи по вашим сделкам.",
  "clientCardW1.payments.date": "Дата",
  "clientCardW1.payments.deal": "Сделка",
  "clientCardW1.payments.amount": "Сумма",
  "clientCardW1.payments.account": "Касса / способ",
  "clientCardW1.payments.status": "Статус",

  "inboxFilter.account": "Аккаунт",
  "inboxFilter.allAccounts": "Все аккаунты",
  "inboxFilter.branch": "Филиал",
  "inboxFilter.allBranches": "Все филиалы",
  "inboxFilter.mode": "Режим",
  "inboxFilter.allModes": "Все режимы",
  "inboxFilter.mode.ai": "Отвечает AI",
  "inboxFilter.mode.ai_draft": "AI пишет черновик",
  "inboxFilter.mode.human": "Отвечает оператор",
  "inboxFilter.more": "Фильтры",
  "inboxFilter.handoff": "Передано от AI",
  "inboxFilter.reset": "Сбросить",

  "threadRead.notice": "Этот диалог ведёт {name}. Вы можете только читать его.",

  "threadLink.action": "Отправить ссылку на оплату",
  "threadLink.noDeal": "Ссылка привязывается к сделке. Сначала нажмите «Создать сделку».",
  "threadLink.summaryFailed": "Не удалось прочитать остаток по сделке.",
  "threadLink.message": "Ссылка на оплату: {amount} · {gateway}\n{url}",
  "threadLink.queued": "Ссылка поставлена в очередь.",
  "paymentLink.resend": "Отправить снова",
  "paymentLink.sending": "Ссылка отправляется в диалог.",
};
